module.exports = __webpack_public_path__ + "up-5c61f30b.png";